import { render, staticRenderFns } from "./ActivityHistoryList.vue?vue&type=template&id=b4677c36"
import script from "./ActivityHistoryList.vue?vue&type=script&lang=js"
export * from "./ActivityHistoryList.vue?vue&type=script&lang=js"
import style0 from "./ActivityHistoryList.vue?vue&type=style&index=0&id=b4677c36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports